import type { ReactNode } from 'react';
import React from 'react';
import combineStyles from '../utils/combineStyles';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import { useAppSelector } from '../app/hooks';

/**
 * # Section Container
 *
 * This is a wrapper component for sections on a page.
 * This component should follows after a <SectionHeading/>
 *
 * @param style
 * @returns
 */
const SectionContainer = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
}) => {
  const isMobile = useAppSelector(getDeviceTypeMobile);

  return (
    <div
      style={combineStyles(
        styles.sectionContainer,
        isMobile && styles.sectionContainerMobile,

        style,
      )}
    >
      {children}
    </div>
  );
};

export default SectionContainer;

const styles: Styles = {
  sectionContainer: {
    padding: '0 50px',
  },
  sectionContainerMobile: {
    padding: '0 30px',
  },
};
